import { Schema } from 'normalizr';
import { transformUtil } from '@eb/transformation-utils';

import { OrderResponse } from '../../api/models/order';
import { QuestionsCollection, InteractiveQuestion } from '../models/survey';

const orderSchema = new Schema('order');

interface Order {
    survey: Array<InteractiveQuestion>;
    questions: QuestionsCollection;
}

const getTransformedOrderFromOrderResponse = (data: OrderResponse) => {
    const transformedOrder = transformUtil({
        response: data,
        schema: orderSchema,
    });

    if (!transformedOrder) {
        return null;
    }

    return transformedOrder.entities.order[transformedOrder.result] as Order;
};

export const getInteractiveQuestionsFromOrderResponse = (
    data: OrderResponse,
) => {
    const order = getTransformedOrderFromOrderResponse(data);

    return order ? order.survey : null;
};

export const getQuestionsCollectionFromOrderResponse = (
    data: OrderResponse,
) => {
    const order = getTransformedOrderFromOrderResponse(data);

    return order ? order.questions : null;
};
